export default __webpack_public_path__ + "static/media/Beachy-Turquoise-Diffuser-Stretch-Bracelet.55f455e8.jpg";